import { FunctionComponent } from "react";
import { Modal, Box } from "@mui/material";
import { usePanelContext } from "../../context/PanelContext";
import CloseButton from "../Icons/CloseButton";
import ExpandedDocumentCard from "../ExpandedDocumentCard";
import { CardViewOption } from "../CardItem/ToggleCardView";
import Basket from "../Basket";

const modalStyle = {
	position: "absolute",
	top: "53.5%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "fit-content",
	height: "fit-content",
	borderRadius: "12px",
	boxShadow: 24,
};

const CardViewModal: FunctionComponent = ({}) => {
	const { cardView, closeCardView } = usePanelContext();

	if (!cardView) {
		return null;
	}

	return (
		<Modal
			open
			hideBackdrop
			disableEnforceFocus
			disableAutoFocus
			sx={{ pointerEvents: "none" }}
			onClose={closeCardView}
		>
			<Box sx={modalStyle}>
				<Box
					sx={{
						position: "relative",
						pointerEvents: "auto",
						backgroundColor: "transparent",
					}}
				>
					<CloseButton
						onClick={closeCardView}
						sx={{
							position: "absolute",
							top: -30,
							right: "0px",
							cursor: "pointer",
						}}
					/>
					{cardView.view !== CardViewOption.BASKET && <ExpandedDocumentCard />}
					{cardView.view === CardViewOption.BASKET && <Basket />}
				</Box>
			</Box>
		</Modal>
	);
};

export default CardViewModal;
